import * as React from "react";
import "./styles.scss";
import Header from "./components/Header/Header";
import Top from "./components/Top/Top";
import Main from "./components/Main/Main";
import FetchData from "./backend/FetchData";
import Configuration from "./components/Configuration/Configuration";
import Process from "./components/Process/Process";
import {Fragment} from "react";
import SideBar from "./components/SideBar/SideBar";
import SideBarButton from "./components/SideBar/SideBarButton";
import Create from "./components/Configuration/Create";
import Import from "./components/Configuration/Import";
import Aside from "./components/Aside/Aside";
import BackgroundUpload from "./components/BackgroundUpload/BackgroundUpload";
import KeySolver from "./KeySolver";
import Untouched from "./Untouched";
import Measure from "./components/Measure/Measure";
import Request from "./components/Request/Request";

class App extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			product: false,
			loading: true,
			fullScreen: false,
			background: false,
			awningExtend: true,
			volantExtend: true,

			configuration: [],

			renderFrame: true
		}
		this.fetchProduct = this.fetchProduct.bind(this);
		this.toggleFullScreen = this.toggleFullScreen.bind(this);
		this.null = this.null.bind(this);
		this.setBackground = this.setBackground.bind(this);

		this.handleAwningExtend = this.handleAwningExtend.bind(this);
		this.setConfiguration = this.setConfiguration.bind(this);

		this.handleVarioVolant = this.handleVarioVolant.bind(this);
	}

	toggleFullScreen() {
		// console.log('toggle fullscreen')
		// this.setState(prevState => ({
		// 	fullScreen: !prevState.fullScreen
		// }));
		if(document.querySelector('.top')) {
			document.querySelector('.top').classList.toggle('fullscreen');
			document.getElementById('fullscreenInfo').classList.toggle('d-none');
			document.getElementById('requestButton').classList.toggle('d-none');
		}
	}

	setConfiguration() {
		const configuration = document.getElementById('root').dataset.configuration;
		if(configuration) {
			this.setState({configuration: JSON.parse(configuration)}, () => {
				const {configuration} = this.state;
				for(let i in configuration) {
					const id = configuration[i].id;
					const value = configuration[i].value;
					if(id && value) {
						console.log(`${id}: ${value}`)
						document.getElementById(id).value = value;
					}
				}
			});
		}
	}

	fetchProduct() {
		this.setState({loading: true}, () => {
			const uriPathSegment = document.getElementById('root').dataset.uripathsegment;
			FetchData(`/api/product/get/${uriPathSegment}`, 'GET').then(result => {
				console.log(result);
				this.setState({product: result}, () => {
					this.setState({loading: false}, () => {
						this.setConfiguration();
						const currentTitle = document.title;
						document.title = `${this.state.product.name} - ${currentTitle}`;
					});
				});
			});
		});
	}

	null() {
		// console.log('null');
	}

	setBackground(backgroundImageUri) {
		this.setState({background: backgroundImageUri})
	}

	handleAwningExtend() {
		// this.setState(prevState => ({ awningExtend: !prevState.awningExtend }), () => {
		// 	if(document.getElementById('check-animation')) {
		// 		document.getElementById('check-animation').click();
		// 	}
		// });

		if(document.getElementById('check-animation')) {
			document.getElementById('check-animation').click();
			document.getElementById('sbbcheck-animation').style.pointerEvents = 'none';
			setTimeout(function(){
				document.getElementById('sbbcheck-animation').style.pointerEvents = 'all';
			}, 2000);
		}
	}

	handleVarioVolant() {
		if(document.getElementById('check-animation_VV')) {
			document.getElementById('check-animation_VV').click();
		}
	}

	componentDidMount() {
		this.fetchProduct();

		const queryParams = new URLSearchParams(window.location.search);
		if (queryParams.has('renderFrame') && queryParams.get('renderFrame') === 'false') {
			console.log('Der Parameter "renderFrame" ist auf "false" gesetzt.');
			this.setState({renderFrame: false});
		}
	}

	render() {

		const {product, loading, fullScreen, background, awningExtend, volantExtend, renderFrame} = this.state;
		const hasVariovolant = product ? (product.properties.variovolant) : false;

		return (
			<Fragment>
				{loading &&
					<Process />
				}
				{renderFrame ?
					<Fragment>
						<div className="App">
							{renderFrame ?
								<Fragment>

								</Fragment>
								:
								<Fragment>

								</Fragment>
							}
							<input type="hidden" id="background" defaultValue={background} />
							<input type="hidden" id="product" defaultValue={product.shortcut} />
							<div className="header">
								<Header title={product.name} />
							</div>
							<div className="top" >
								{/*<div className={`top${fullScreen ? ` fullscreen` : ``}`}>*/}
								<SideBar>
									<SideBarButton
										label="Maße anzeigen"
										icon="fas fa-ruler-combined"
										// onClick={() => this.null()}
									>
										<Fragment>
											<Aside title="Abmessungen">
												<Measure />
											</Aside>
										</Fragment>
									</SideBarButton>
									<SideBarButton
										// label={`Markise ${awningExtend ? `einfahren` : `ausfahren`}`}
										label={`Markise einfahren/ausfahren`}
										id="check-animation"
										// icon="fas fa-play-circle"
										icon="fas fa-exchange-alt"
										// handleAsCheckbox={true}
										// onClick={() => this.setState(prevState => ({ awningExtend: !prevState.awningExtend }))}
										onClick={() => this.handleAwningExtend()}
									/>
									{hasVariovolant &&
										<Fragment>
											<input type="checkbox" id="check-animation_VV" className="d-none"/>
											<SideBarButton
												id="animation_VV"
												label={`Variovolant einfahren/ausfahren`}
												icon="fas fa-exchange-alt fa-rotate-90"
												onClick={() => this.handleVarioVolant()}
											/>
										</Fragment>
									}
								</SideBar>
								<Request children={product.children} name={product.name} />
								{product &&
									<Fragment>
										{product.children.length > 0 &&
											<Top fullScreen={fullScreen} product={product} background={background} onClick={() => this.toggleFullScreen()} />
										}
									</Fragment>
								}
								<SideBar position="right" >
									<SideBarButton
										label={fullScreen ? 'Vollbildansicht beenden' : 'Vollbildansicht'}
										icon={fullScreen ? 'fas fa-compress-arrows-alt' : 'fas fa-expand-arrows-alt'}
										onClick={() => this.toggleFullScreen()}
									/>
									{/*<SideBarButton*/}
									{/*	label="Augmented Reality"*/}
									{/*	icon="fas fa-cubes"*/}
									{/*>*/}
									{/*	<Fragment>*/}
									{/*		<Aside title="Augmented Reality">*/}
									{/*			<p>Starten Sie die Augmented Reality Ansicht und betrachten Sie Ihre Markisenkonfiguration gleich auf Ihrer Terrasse.</p>*/}
									{/*			<a href="https://apps.apple.com/at/app/wo-wo-sunlight-designer" target="_blank" className="btn btn-outline-primary btn-lg w-100 d-block" >*/}
									{/*				AR-App starten*/}
									{/*			</a>*/}
									{/*		</Aside>*/}
									{/*	</Fragment>*/}
									{/*</SideBarButton>*/}
									{!background &&
										<SideBarButton
											label="Hintergrundbild"
											icon="fas fa-image"
										>
											<BackgroundUpload setBackground={(p) => this.setBackground(p)} />
										</SideBarButton>
									}
									{background &&
										<SideBarButton
											label="Hintergrundbild löschen"
											icon="fas fa-trash"
											onClick={() => this.setState({background: false})}
										/>
									}
								</SideBar>
							</div>
							<div className="main">
								<Main children={product.children} shortcut={product.shortcut} />
								{/*<SideBar position="right" >*/}
								{/*	<SideBarButton*/}
								{/*		label="Konfiguration speichern"*/}
								{/*		icon="fas fa-save"*/}
								{/*		position="bottom"*/}
								{/*	>*/}
								{/*		<Create />*/}
								{/*	</SideBarButton>*/}
								{/*	<SideBarButton*/}
								{/*		label="Konfiguration importieren"*/}
								{/*		icon="fas fa-file-import"*/}
								{/*		position="bottom"*/}
								{/*	>*/}
								{/*		<Import setBackground={(p) => this.setBackground(p)} />*/}
								{/*	</SideBarButton>*/}
								{/*</SideBar>*/}
							</div>
						</div>
						{product &&
							<Fragment>
								{product.children.length > 0 &&
									<Fragment>
										<Untouched children={product.children} />
									</Fragment>
								}
							</Fragment>
						}
					</Fragment>
					:
					<Fragment>
						{product &&
							<Fragment>
								{product.children.length > 0 &&
									<Top fullScreen={fullScreen} single={true} product={product} background={background} onClick={() => this.toggleFullScreen()} />
								}
							</Fragment>
						}
					</Fragment>
				}

			</Fragment>
		);
	}
}

export default App;
